import { useState } from "react";
import PropTypes from "prop-types";
import IconChevronUp from "assets/images/icons/chevron-up.svg";
import { useCollapse } from 'react-collapsed'

function Filter({ title, type, children }) {
  const [isExpanded, setExpanded] = useState(true)
  const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded })

  let content = children;
  if (type === 'option-list') {
    content = (
      <div className="expandable expandable--no-header">
        { children }
      </div>
    )
  }

  return (
    <div className="filters__option">
      <h3 { ...getToggleProps({
        onClick: () => setExpanded(!isExpanded),
      }) }>{ title } <img src={ IconChevronUp } className={ !isExpanded ? 'rotate180' : '' }
                          alt="Toon of verberg opties"/></h3>
      <section { ...getCollapseProps() }>
        { content }
      </section>
    </div>
  );
}

Filter.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.string,
}

export default Filter;
